import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../../shared/components/DashboardHeader';
import SideMenu from '../../shared/components/SideMenu';
import Footer from '../../shared/components/Footer';

import HttpCall from '../../api/Http';
import SerializeClass from '../../shared/Utils/serialized';
import User from '../../shared/Utils/User';
import axios from 'axios';
import Alert from '../../shared/Utils/AlertBox';
import Loader from '../../shared/components/Loader';
import Moment from 'react-moment';
import swal from 'sweetalert';

export default function SelectedLead() {

  const [sequenceList, setSequenceList] = useState([])
  const [sequenceLeadList, setSequenceLeadList] = useState([])
  const [leadList, setLeadList] = useState([])
  const [sequenceID, setsequenceID] = useState(0)
  const [leadID, setLeadID] = useState(0)
  const [loader, setLoader] = useState(false);
  const [recordID, setRecordID] = useState(0);
  const [inputValue, setInputValue] = useState({ email: "", password: "", url: "", searchText: "" });
  const { email, password, url, searchText } = inputValue;
  const user = User.getUser()

  const handleChange = (e) => {
    const { name, value, searchText } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value, }));
  };


  useEffect(() => {
    let arr = [];
    arr.push({ P_user_id: user[0].Id });
    let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };
    let url = `https://api.getbound.ai/api/user/getUserSequence?Params=${p}`;
    axios.get(url, header).then(response => {
      if (response.data.code == 200) {
        setSequenceList(response.data.data);
      } else {
        alert(response.data.msg);
      }
    }).catch(err => {
      console.log(err);
    })

    let url2 = `https://api.getbound.ai/api/user/getLeadList?Params=${p}`;
    axios.get(url2, header).then(response => {
      if (response.data.code == 200) {
        setLeadList(response.data.data);
      } else {
        alert(response.data.msg);
      }
    }).catch(err => {
      console.log(err);
    })

    getSequenceLeadLists(0);

  }, [])

  function getSequenceLeadLists(type) {
    let arr = [];
    arr.push({ P_user_id: user[0].Id });
    if (type == 0)
      arr.push({ P_Search_Text: searchText });
    let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };

    let url = `https://api.getbound.ai/api/user/getUserSequenceLeadList?Params=${p}`;
    axios.get(url, header).then(response => {
      if (response.data.code == 200) {
        setSequenceLeadList(response.data.data);
      } else {
        alert(response.data.msg);
      }
      setLoader(false);
    }).catch(err => {
      console.log(err);
      setLoader(false);
    })
  }

  function selectSequence(e) {
    const select = e.target;
    setsequenceID(select.children[select.selectedIndex].value);
  }
  function selectedLead(e) {
    const select = e.target;
    setLeadID(select.children[select.selectedIndex].value);
  }

  function addSequenceLead(e) {

    e.preventDefault();

    if (leadID == 0) {
      return Alert.show('Error', 'Please select the Lead name', 'error')
    }
    if (sequenceID == 0) {
      return Alert.show('Error', 'Please select the sequence name', 'error')
    }

    let requestData = new FormData();
    let arr = [];
    if (recordID > 0) {
      arr.push({ P_id: recordID });
      arr.push({ P_sequence_id: sequenceID });
      arr.push({ P_lead_id: leadID });
      arr.push({ P_updated_by: user[0].Id });
    } else {
      arr.push({ P_user_id: user[0].Id });
      arr.push({ P_sequence_id: sequenceID });
      arr.push({ P_lead_id: leadID });
      arr.push({ P_created_by: user[0].Id });
    }
    let p = SerializeClass.getSerializedData(arr);
    let url = recordID ? '/api/user/updateSequenceLeadList' : `/api/user/addSequenceLeadList`
    requestData.append('Params', p);
    setLoader(true);
    HttpCall.postRequest2(url, requestData).then(response => {
      if (response.data.code == 200) {
        Alert.show("Success!", leadID ? "Squence Lead List Updated Successfully." : "Squence Lead List Added Successfully.", "success");
        window.location.reload(false);
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
      setLoader(false);
    }).catch(err => {
      console.log(err);
      setLoader(false);
    })
  }

  function deleteSequenceLead(row) {

    var popupHtml = document.createElement("div");
    popupHtml.innerHTML = "Are you sure you want to deleted?";

    swal({
      title: "Confirmation",
      content: popupHtml,
      icon: "warning",
      buttons: [
        'No',
        'Yes'
      ]
    }).then((result) => {
      if (result) {
        let requestData = new FormData();
        let arr = [];
        arr.push({ P_updated_by: user[0].Id });
        arr.push({ P_id: row.id });
        let p = SerializeClass.getSerializedData(arr);
        let url = '/api/user/deleteSequenceLeadList'
        requestData.append('Params', p);
        setLoader(true);
        HttpCall.postRequest2(url, requestData).then(response => {
          if (response.data.code == 200) {
            Alert.show("Success!", "Squence Lead List Deleted Successfully.", "success");
            window.location.reload(false);
          } else {
            Alert.show("Error!", response.data.msg, "error");
          }
          setLoader(false);
        }).catch(err => {
          console.log(err);
          setLoader(false);
        })
      }
    })



  }

  const editLead = (row) => {
    setRecordID(row.id);
    setsequenceID(row.sequence_id);
    setLeadID(row.lead_id)
  }

  function searchRecord(e) {
    e.preventDefault();
    setLoader(true);
    getSequenceLeadLists(0);
  }

  function clearSearch(e) {
    inputValue.searchText = '';
    e.preventDefault();
    setLoader(true);
    getSequenceLeadLists(1);
  }


  return (
    <>
      <DashboardHeader />
      {loader && <Loader />}
      <div className="container-fluid page-body-wrapper">
        <SideMenu />

        <div className="main-panel">

          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Sequence > Select Lead List</h4>
                    <p className="card-description">
                      Note: Select Lead List for the sequence
                    </p>
                    <form className="forms-sample">

                      <div className="form-group">
                        <label>Select Lead Name</label>
                        <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                          onChange={selectedLead} value={leadID}>
                          <option value="">Select Lead List</option>
                          {leadList.map(data => (
                            <option key={data.id} value={data.id}>
                              {data.lead_list_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Sequence Name</label>
                        <select className="js-example-basic-single w-100 customselect form-control form-control-lg"
                          onChange={selectSequence} value={sequenceID}>
                          <option value="">Select Sequence</option>
                          {sequenceList.map(data => (
                            <option key={data.id} value={data.id}>
                              {data.sequence_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <p class="card-description">
                        <a href="lead-list" class="policylink">Create Lead List</a>
                      </p>
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit" className="btn btn-primary me-2 savebtn"
                            onClick={addSequenceLead}>Save</button>
                        </div>
                        <div className="col-md-6">
                          <button className="btn btn-light me-2 savebtn">Cancel</button>
                        </div>
                      </div>

                    </form>
                  </div>
                </div>
              </div>


              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Platform </h4>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input type="text" className="form-control form-control-lg"
                            onChange={handleChange} value={searchText} name="searchText" placeholder='Search ' />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <button type="submit" className="btn btn-primary me-2 savebtn" onClick={searchRecord}>
                            Search
                          </button>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <button type="submit" className="btn btn-primary me-2 savebtn" onClick={clearSearch}>
                            Clear Search
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Lead List</th>
                            <th>Sequence</th>
                            <th>Sequence File Name</th>
                            <th>Lead File Name</th>
                            <th>Created</th>
                            <th>Action</th>
                            {/* <th>Status</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {sequenceLeadList.length > 0 && sequenceLeadList.map((data, index) => (<tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.lead_list_name}</td>
                            <td>{data.sequence_name}</td>
                            <td>{data.sequence_file_name}</td>
                            <td>{data.lead_file_name}</td>
                            <td><Moment format="DD-MM-YYYY">{data.created_on}</Moment></td>
                            {/* <td><label className="badge badge-danger">{data.status_id}</label></td> */}
                            <td>
                              <button type="submit" className="btn btn-primary me-1 savebtn" onClick={() => editLead(data)}>Edit</button>
                              <button type="submit" className="btn btn-primary me-1 savebtn" onClick={() => deleteSequenceLead(data)}>Delete</button>
                            </td>
                          </tr>))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}